import React from 'react';
import { Modal, Button, Row, Col, Card, Avatar } from 'antd';
import '../Atoms/Nominee.css';


interface TeamDetailsModalProps {
    visible: boolean;
    onCancel: () => void;
    empData: any;
    teamData: any;
}

const getInitials = (name: string) => {
    const names = (name ?? '').trim().split(' ');
    if (names.length < 2) return (name ?? '').substring(0, 2).toUpperCase();
    return `${names[0].charAt(0)}${names[names.length - 1].charAt(0)}`.toUpperCase();
};

const TeamDetailsModal: React.FC<TeamDetailsModalProps> = ({ visible, onCancel, empData, teamData }) => {
    const teamMembers = Array.isArray(teamData) ? teamData : [];
    const handleCancel = () => {
        onCancel();
    };

    return (
        <>
            <Modal
                title="Team Details"
                open={visible}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel
                    </Button>,
                ]}
                width={1000}
            >
                {empData ? (
                    <>
                        <Row gutter={[16, 16]}>
                            <Col span={12}><strong>Team</strong></Col>
                        </Row>
                        <Row gutter={[16, 16]}>
                            <Col span={12}>{empData.teamName}</Col>
                        </Row>

                        <Row style={{ marginTop: '20px' }}>
                            <Col span={24}><strong>Team Members</strong></Col>
                        </Row>

                        <Row gutter={[16, 16]}>
                            {teamMembers.length === 0 ? (
                                <Col span={24}>
                                    <div style={{ color: '#999', fontStyle: 'italic', padding: '12px 0' }}>
                                        No team member data available for this nomination.
                                    </div>
                                </Col>
                            ) : (
                                teamMembers.map((member: any, index: any) => (
                                    <Col key={index} span={8}>
                                        <Card>
                                            <Card.Meta
                                                avatar={
                                                    <Avatar style={{ backgroundColor: '#87d068' }}>
                                                        {getInitials(member.name)}
                                                    </Avatar>
                                                }
                                                title={member.name}
                                                description={member.title}
                                            />
                                        </Card>
                                    </Col>
                                ))
                            )}
                        </Row>
                    </>
                ) : (<div>Loading...</div>)}
            </Modal>
        </>
    );
};

export default TeamDetailsModal;
